import _ from "lodash";
import React from "react";
import classes from "./TaggedStudents.scss";
import ProfileCascade from "UIComponents/ProfileCascade";
import I18nHOC from "UIComponents/I18nHOC";
import { Tooltip } from "AppComponents/ArchivedComponents";
import { AvatarGroup, Avatar } from "@toddle-edu/ds-web";
import { getFormattedStudentName } from "Utils/GetFormattedStudentName";
import { getDefaultStudentNameOrderPreference } from "modules/CommonSelectors";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { getFormattedUserName } from "Utils/GetFormattedUserName";

const ProfileCadeStyle = {
  width: 32,
  height: 32,
  marginRight: 4,
};

const getProfileCascadeItems = students => {
  return _.map(students, student => {
    const { id, profileImage } = student;
    return {
      id: id,
      value: getFormattedUserName({ user: student }),
      imageUrl: profileImage,
    };
  });
};

class TaggedStudents extends React.PureComponent {
  render() {
    const {
      taggedStudents = [],
      isAllStudentsSelected,
      t,
      showAvatarGroup,
      containerStyle,
      defaultStudentNameOrderPreference,
      avatarGroupProps = {},
    } = this.props;
    const moreLength = 1;

    const studentItems = _.map(taggedStudents, item => {
      return {
        name: getFormattedStudentName({
          student: item,
          showStudentUID: true,
          isFormattedNameV2: true,
          defaultStudentNameOrderPreference,
        }),
        isArchived: item.isArchived,
      };
    });
    return (
      <div className={classes.container} style={containerStyle}>
        {_.get(taggedStudents, "length", 0) > 0 ? (
          showAvatarGroup ? (
            <AvatarGroup
              shape={"square"}
              size={"small"}
              shade={"light"}
              theme={"light"}
              iconType={"individual"}
              {...avatarGroupProps}
            >
              {_.map(taggedStudents, student => (
                <Avatar
                  key={student.id}
                  name={getFormattedStudentName({
                    student,
                    isFormattedNameV2: true,
                    defaultStudentNameOrderPreference,
                    showStudentUID: true,
                  })}
                  src={student.profileImage}
                />
              ))}
            </AvatarGroup>
          ) : (
            <ProfileCascade
              items={getProfileCascadeItems(taggedStudents)}
              customStyle={ProfileCadeStyle}
              length={moreLength}
            />
          )
        ) : (
          <div className={classes.textPlaceholder}>{t("common:select")}</div>
        )}
        {_.get(taggedStudents, "length", 0) > 0 && !showAvatarGroup && (
          <div className={classes.tagStudentNameContainer}>
            <Tooltip
              data={studentItems}
              keyToMap="name"
              tooltipPlacement={"bottom"}
              length={moreLength}
              isAllSelected={isAllStudentsSelected}
              allItemsText={t("common:all_label", {
                label: t("common:student_plural"),
              })}
              label={t("common:students")}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );
  return { defaultStudentNameOrderPreference };
};

export default compose(
  connect(mapStateToProps, null),
  I18nHOC({ resource: ["common"] })
)(TaggedStudents);
